(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-styleguide"]) return;
  try {
    
  const toggleDarkMode = document.querySelector(
    '#styleguide-form-elements [name="toggle-dark-mode"]'
  );
  const container = document.querySelector('#styleguide-form-elements');
  toggleDarkMode?.addEventListener('change', (event) => {
    container?.classList.toggle('color-scheme-primary', event.target.checked);
    container?.classList.toggle('color-scheme-white', !event.target.checked);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-widget')) {
    class ReviewsWidget extends HTMLElement {
      connectedCallback() {
        this.#setupToggle();

        const url = this.dataset.url;
        if (!url) return;

        const limit = parseInt(this.dataset.limit) || 15;

        const cached = this.#readCache(url);
        if (cached) {
          this.#render(cached, limit);
          return;
        }

        fetch(url)
          .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
          .then((data) => {
            this.#writeCache(url, data);
            this.#render(data, limit);
          })
          .catch(() => {
            // Keep the static fallback content rendered by Liquid.
          });
      }

      #cacheKey(url) {
        return `reviews-widget-cache:${url}`;
      }

      #today() {
        return new Date().toLocaleDateString('en-CA');
      }

      #readCache(url) {
        try {
          const raw = localStorage.getItem(this.#cacheKey(url));
          if (!raw) return null;
          const entry = JSON.parse(raw);
          return entry.date === this.#today() ? entry.data : null;
        } catch {
          return null;
        }
      }

      #writeCache(url, data) {
        try {
          localStorage.setItem(this.#cacheKey(url), JSON.stringify({ date: this.#today(), data }));
        } catch {
          // Storage unavailable (private browsing, quota, etc). Not fatal, just skip caching.
        }
      }

      #setupToggle() {
        const wrap = this.querySelector('[data-reviews-grid-wrap]');
        const button = this.querySelector('[data-reviews-grid-toggle]');
        if (!wrap || !button) return;

        requestAnimationFrame(() => {
          const overflows = wrap.scrollHeight > wrap.clientHeight + 4;
          button.hidden = !overflows;
        });

        if (button.dataset.bound) return;
        button.dataset.bound = 'true';
        const expandLabel = button.textContent.trim();
        button.addEventListener('click', () => {
          const expanded = wrap.classList.toggle('is-expanded');
          button.textContent = expanded ? 'Toon minder reviews' : expandLabel;
        });
      }

      #render(data, limit) {
        const reviews = Array.isArray(data.reviews) ? data.reviews : [];
        if (!reviews.length) return;

        const average = data.ratings?.average ?? data.ratings?.last_12_months?.average;
        const count = data.ratings?.quantity ?? reviews.length;

        const scoreEl = this.querySelector('[data-reviews-score]');
        if (scoreEl && average != null) scoreEl.textContent = average;

        const countEl = this.querySelector('[data-reviews-count]');
        if (countEl) countEl.textContent = count;

        const allLink = this.querySelector('[data-reviews-all-link]');
        if (allLink && !allLink.getAttribute('href') && data.urls?.view) {
          allLink.href = data.urls.view;
          allLink.removeAttribute('hidden');
        }

        let distribution = data.star_distribution;
        if (!distribution) {
          distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
          reviews.forEach((review) => {
            const stars = Math.min(5, Math.max(1, Math.round(parseFloat(review.rating) / 2)));
            distribution[stars]++;
          });
        }
        const distributionTotal = Object.values(distribution).reduce((sum, value) => sum + Number(value), 0);

        this.querySelectorAll('[data-star]').forEach((row) => {
          const star = parseInt(row.dataset.star);
          const value = Number(distribution[star]) || 0;
          const percent = distributionTotal ? Math.round((value / distributionTotal) * 100) : 0;
          const fill = row.querySelector('[data-reviews-bar-fill]');
          const countLabel = row.querySelector('[data-reviews-bar-count]');
          if (fill) fill.style.width = `${percent}%`;
          if (countLabel) countLabel.textContent = value;
        });

        const grid = this.querySelector('[data-reviews-grid]');
        if (!grid) return;

        const bestFirst = [...reviews].sort((a, b) => {
          const ratingDiff = parseFloat(b.rating) - parseFloat(a.rating);
          if (ratingDiff !== 0) return ratingDiff;
          return new Date(b.date) - new Date(a.date);
        });

        grid.innerHTML = bestFirst
          .slice(0, limit)
          .map((review) => this.#renderCard(review))
          .join('');

        this.#setupToggle();
      }

      #reviewText(review) {
        return (
          review.content?.find((item) => item.question === 'Beschrijf uw ervaring' && item.answer)?.answer ??
          review.content?.find((item) => item.question === 'Beschrijf uw ervaring in een regel' && item.answer)
            ?.answer ??
          ''
        );
      }

      #renderCard(review) {
        const stars = Math.min(5, Math.max(1, Math.round(parseFloat(review.rating) / 2)));
        const text = this.#reviewText(review);

        const starsMarkup = Array.from({ length: 5 }, (_, index) => {
          const filled = index < stars;
          return `
            <div class="icon flex justify-center [&>svg]:block [&>svg]:size-full [&>svg]:max-h-full [&>svg]:min-h-0 [&>svg]:max-w-full [&>svg]:min-w-0 [&>svg]:shrink-0 [&>svg]:self-stretch size-4 ${filled ? 'reviews__star--filled' : 'reviews__star--empty'}">
              ${this.#starSvg(filled)}
            </div>
          `;
        }).join('');

        return `
          <div class="reviews__card">
            <div class="reviews__card-header">
              <p class="reviews__card-name">${this.#escape(review.author)}</p>
              <span class="reviews__card-stars">${starsMarkup}</span>
            </div>
            ${text ? `<reviews-card-text><p class="reviews__card-text">${this.#escape(text)}</p></reviews-card-text>` : ''}
          </div>
        `;
      }

      #starSvg(filled) {
        return filled
          ? '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M12.806 1.691a.9.9 0 0 0-.802-.491.9.9 0 0 0-.803.491L8.441 7.1l-5.996.952a.902.902 0 0 0-.499 1.527l4.29 4.293-.945 5.996a.903.903 0 0 0 1.298.945l5.415-2.752 5.411 2.753a.9.9 0 0 0 1.297-.945l-.948-5.997 4.29-4.293a.9.9 0 0 0 .217-.915.9.9 0 0 0-.716-.612L15.563 7.1z"/></svg>'
          : '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M12.004 1.2c.337 0 .649.191.802.491L15.563 7.1l5.996.952a.902.902 0 0 1 .498 1.527l-4.293 4.293.948 5.996a.903.903 0 0 1-1.297.945l-5.411-2.752-5.411 2.753a.9.9 0 0 1-1.298-.945l.945-5.997-4.29-4.293a.9.9 0 0 1-.217-.915.9.9 0 0 1 .716-.612L8.445 7.1l2.76-5.408a.9.9 0 0 1 .803-.491zm0 2.88L9.836 8.325a.9.9 0 0 1-.66.48l-4.706.75 3.368 3.371a.9.9 0 0 1 .25.777l-.742 4.706 4.249-2.16a.9.9 0 0 1 .817 0l4.25 2.16-.743-4.706a.9.9 0 0 1 .251-.777l3.367-3.371-4.706-.75a.9.9 0 0 1-.66-.48z"/></svg>';
      }

      #escape(value) {
        const div = document.createElement('div');
        div.textContent = value ?? '';
        return div.innerHTML;
      }
    }

    customElements.define('reviews-widget', ReviewsWidget);
  }

  if (!customElements.get('reviews-card-text')) {
    class ReviewsCardText extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.#setup());
      }

      #setup() {
        const text = this.querySelector('.reviews__card-text');
        if (!text || text.scrollHeight <= text.clientHeight + 2) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reviews__card-more';
        button.textContent = 'Lees meer';
        button.addEventListener('click', () => {
          const expanded = text.classList.toggle('is-expanded');
          button.textContent = expanded ? 'Lees minder' : 'Lees meer';
        });
        this.append(button);
      }
    }

    customElements.define('reviews-card-text', ReviewsCardText);
  }

  } catch(e) { console.error(e); }
})();
})();
